var _path, _path2, _path3, _path4, _path5, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AI_File_Icon",
    "data-name": "AI File Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_509393",
    "data-name": "Path 509393",
    d: "M109.859,58.9c.092-1.3.141-2.6.141-3.923a55,55,0,1,0-69.65,53Z",
    fill: "#9e7120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509394",
    "data-name": "Path 509394",
    d: "M203.754,120.127,161.376,77.913,119.1,154.487l14.83,14.773a55.328,55.328,0,0,0,69.828-49.133Z",
    transform: "translate(-93.755 -61.238)",
    fill: "#6c4e16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509395",
    "data-name": "Path 509395",
    d: "M154.032,134.081,149.07,77.913H119.1V129.2Z",
    transform: "translate(-93.754 -61.529)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509396",
    "data-name": "Path 509396",
    d: "M285.812,129.2V95.008L273.6,90.123l-4.884-12.21H255.711l.078,56.168Z",
    transform: "translate(-201.2 -61.529)",
    fill: "#e8e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509397",
    "data-name": "Path 509397",
    d: "M314.991,95.008V77.913l17.095,17.095Z",
    transform: "translate(-247.474 -61.529)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72288",
    "data-name": "Rectangle 72288",
    width: 59.271,
    height: 26.863,
    transform: "translate(25.341 66.51)",
    fill: "#fcb433"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_272795",
    "data-name": "Group 272795",
    transform: "translate(45.691 74.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509398",
    "data-name": "Path 509398",
    d: "M217.387,355.869l-.847,2.142H213.5l5.015-11.623h3.039l4.9,11.623H223.3l-.83-2.142Zm2.557-6.542-1.694,4.3h3.354Z",
    transform: "translate(-213.502 -346.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509399",
    "data-name": "Path 509399",
    d: "M279.349,358.01V346.387H282.3V358.01Z",
    transform: "translate(-264.902 -346.387)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.44266ccb8e754a5f9632e2ecc932c7d9.svg";
export { ForwardRef as ReactComponent };